(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panqa-calculadora-corte"] && !Shopify.designMode) return;
  try {
    
  class PanqaCutCalculator {
    constructor(section) {
      this.section = section;
      this.form = section.querySelector('[data-panqa-cut-form]');
      this.sheet = section.querySelector('[data-panqa-cut-sheet]');
      this.modeLabel = section.querySelector('[data-panqa-cut-mode-label]');
      this.results = {};

      section.querySelectorAll('[data-panqa-cut-result]').forEach((item) => {
        this.results[item.dataset.panqaCutResult] = item;
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.update();
      });
      this.form.addEventListener('reset', () => window.requestAnimationFrame(() => this.clear()));
      this.clear();
    }

    readNumber(name, options = {}) {
      const value = Number.parseFloat(this.form.elements[name].value);
      if (!Number.isFinite(value) || value <= 0) return 0;

      const rounded = Math.round(value * 10) / 10;
      const min = options.min || 0;
      const max = options.max || Number.POSITIVE_INFINITY;
      const normalized = Math.min(Math.max(rounded, min), max);
      this.form.elements[name].value = String(normalized);
      return normalized;
    }

    createLayout(sheetLength, sheetWidth, cutLength, cutWidth, rotated, bounds = {}) {
      const pieceWidth = rotated ? cutLength : cutWidth;
      const pieceLength = rotated ? cutWidth : cutLength;
      const startX = bounds.x ?? 0;
      const startY = bounds.y ?? 0;
      const width = bounds.width ?? sheetWidth;
      const length = bounds.length ?? sheetLength;
      const columns = pieceWidth > 0 ? Math.floor(width / pieceWidth) : 0;
      const rows = pieceLength > 0 ? Math.floor(length / pieceLength) : 0;
      const pieces = [];

      for (let row = 0; row < rows; row += 1) {
        for (let column = 0; column < columns; column += 1) {
          pieces.push({
            x: startX + column * pieceWidth,
            y: startY + row * pieceLength,
            width: pieceWidth,
            length: pieceLength,
            rotated
          });
        }
      }

      return {
        rows,
        columns,
        pieces,
        perSheet: pieces.length,
        horizontalPieces: rotated ? 0 : pieces.length,
        verticalPieces: rotated ? pieces.length : 0,
        label: rotated ? 'Vertical' : 'Horizontal'
      };
    }

    mergeLayouts(label, layouts) {
      const pieces = layouts.flatMap((layout) => layout.pieces);

      return {
        rows: Math.max(...layouts.map((layout) => layout.rows), 0),
        columns: Math.max(...layouts.map((layout) => layout.columns), 0),
        pieces,
        perSheet: pieces.length,
        horizontalPieces: pieces.filter((piece) => !piece.rotated).length,
        verticalPieces: pieces.filter((piece) => piece.rotated).length,
        label
      };
    }

    mixedLayouts(sheetLength, sheetWidth, cutLength, cutWidth) {
      const horizontalRows = Math.floor(sheetLength / cutLength);
      const verticalRows = Math.floor(sheetLength / cutWidth);
      const horizontalColumns = Math.floor(sheetWidth / cutWidth);
      const verticalColumns = Math.floor(sheetWidth / cutLength);
      const layouts = [];

      for (let rows = 1; rows <= horizontalRows; rows += 1) {
        const usedLength = rows * cutLength;
        layouts.push(this.mergeLayouts('Máximo mixto', [
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, false, { length: usedLength }),
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, true, { y: usedLength, length: sheetLength - usedLength })
        ]));
      }

      for (let rows = 1; rows <= verticalRows; rows += 1) {
        const usedLength = rows * cutWidth;
        layouts.push(this.mergeLayouts('Máximo mixto', [
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, true, { length: usedLength }),
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, false, { y: usedLength, length: sheetLength - usedLength })
        ]));
      }

      for (let columns = 1; columns <= horizontalColumns; columns += 1) {
        const usedWidth = columns * cutWidth;
        layouts.push(this.mergeLayouts('Máximo mixto', [
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, false, { width: usedWidth }),
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, true, { x: usedWidth, width: sheetWidth - usedWidth })
        ]));
      }

      for (let columns = 1; columns <= verticalColumns; columns += 1) {
        const usedWidth = columns * cutLength;
        layouts.push(this.mergeLayouts('Máximo mixto', [
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, true, { width: usedWidth }),
          this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, false, { x: usedWidth, width: sheetWidth - usedWidth })
        ]));
      }

      return layouts;
    }

    pickOption(horizontal, vertical, mixed, mode) {
      if (mode === 'horizontal') return horizontal;
      if (mode === 'vertical') return vertical;
      return [horizontal, vertical, ...mixed].reduce((best, layout) => {
        if (layout.perSheet > best.perSheet) return layout;
        return best;
      }, horizontal);
    }

    update() {
      const sheetLength = this.readNumber('sheetLength', { min: 0.1, max: 350 });
      const sheetWidth = this.readNumber('sheetWidth', { min: 0.1, max: 250 });
      const cutLength = this.readNumber('cutLength', { min: 0.1, max: 350 });
      const cutWidth = this.readNumber('cutWidth', { min: 0.1, max: 250 });
      const copies = Math.max(1, Math.floor(this.readNumber('copies')));
      const mode = this.form.elements.mode.value;
      const horizontal = this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, false);
      const vertical = this.createLayout(sheetLength, sheetWidth, cutLength, cutWidth, true);
      const selected = this.pickOption(horizontal, vertical, this.mixedLayouts(sheetLength, sheetWidth, cutLength, cutWidth), mode);
      const sheets = selected.perSheet > 0 ? Math.ceil(copies / selected.perSheet) : 0;
      const totalCopies = sheets * selected.perSheet;
      const sheetArea = sheetLength * sheetWidth;
      const usedArea = selected.perSheet * cutLength * cutWidth;
      const used = sheetArea > 0 ? Math.min(100, (usedArea / sheetArea) * 100) : 0;

      this.writeResult('perSheet', selected.perSheet);
      this.writeResult('columns', selected.horizontalPieces);
      this.writeResult('rows', selected.verticalPieces);
      this.writeResult('sheets', sheets);
      this.writeResult('totalCopies', totalCopies);
      this.writeResult('used', `${Math.round(used)}%`);
      this.writeResult('waste', `${Math.max(0, Math.round(100 - used))}%`);
      this.modeLabel.textContent = mode === 'max' ? `Máximo: ${selected.label}` : selected.label;
      this.renderSheet(sheetLength, sheetWidth, selected);
    }

    writeResult(name, value) {
      if (this.results[name]) this.results[name].textContent = value;
    }

    clear() {
      this.writeResult('perSheet', '0');
      this.writeResult('columns', '0');
      this.writeResult('rows', '0');
      this.writeResult('sheets', '0');
      this.writeResult('totalCopies', '0');
      this.writeResult('used', '0%');
      this.writeResult('waste', '0%');
      this.modeLabel.textContent = 'Máximo';
      this.sheet.innerHTML = '<div class="panqa-cut-calculator__empty">Ingresa las medidas y presiona Calcular.</div>';
    }

    renderSheet(sheetLength, sheetWidth, option) {
      this.sheet.innerHTML = '';

      if (!sheetLength || !sheetWidth || !option.perSheet) {
        const empty = document.createElement('div');
        empty.className = 'panqa-cut-calculator__empty';
        empty.textContent = 'Ingresa medidas válidas para ver el corte.';
        this.sheet.appendChild(empty);
        return;
      }

      this.sheet.style.setProperty('--sheet-ratio', String(sheetWidth / sheetLength));
      option.pieces.forEach((item) => {
        const piece = document.createElement('span');
        piece.className = 'panqa-cut-calculator__piece';
        piece.style.left = `${(item.x / sheetWidth) * 100}%`;
        piece.style.top = `${(item.y / sheetLength) * 100}%`;
        piece.style.width = `${(item.width / sheetWidth) * 100}%`;
        piece.style.height = `${(item.length / sheetLength) * 100}%`;
        this.sheet.appendChild(piece);
      });
    }
  }

  const initPanqaCutCalculators = (root = document) => {
    root.querySelectorAll('[data-panqa-cut-calculator]').forEach((section) => {
      if (!section.panqaCutCalculator) {
        section.panqaCutCalculator = new PanqaCutCalculator(section);
      }
    });
  };

  initPanqaCutCalculators();
  document.addEventListener('shopify:section:load', (event) => initPanqaCutCalculators(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
